import React from 'react'

export const LoadingSkeletonMenus = () => {
    return (
        <div role="status" className="max-w-sm animate-pulse mt-9 pl-2">
            <div className="h-9 bg-[#ffffff70] rounded-full w-full mb-2" />
            <div className="h-8 bg-[#4d76ae] rounded-full w-full mb-2" />
            <div className="h-8 bg-[#4d76ae90] rounded-full w-full mb-2" />
            <div className="h-8 bg-[#4d76ae80] rounded-full w-full mb-2" />
            <div className="h-8 bg-[#4d76ae70] rounded-full w-full mb-2" />
            <div className="h-8 bg-[#4d76ae60] rounded-full w-full mb-2" />
            <div className="h-8 bg-[#4d76ae50] rounded-full w-full mb-2" />
            <div className="h-8 bg-[#4d76ae40] rounded-full w-full mb-2" />
            <span className="sr-only">Loading...</span>
        </div>

    )
}

export const LoadingSkeletonChart = () => {
    return (
        // <div role="status" className="w-56 py-6 rounded animate-pulse m-auto">
        //     <div className="flex items-baseline mt-4 gap-2">
        //         <div className="w-full bg-gray-200 rounded-t-lg h-44 ms-6" />
        //         <div className="w-full h-28 ms-6 bg-gray-200 rounded-t-lg" />
        //         <div className="w-full bg-gray-200 rounded-t-lg h-40 ms-6" />
        //         <div className="w-full h-28 ms-6 bg-gray-200 rounded-t-lg" />
        //     </div>
        //     <span className="sr-only">Loading...</span>
        // </div>
        <div role="status" className="flex loading-wave w-56 my-36 rounded animate-pulse m-auto">
            <div className="loading-bar"></div>
            <div className="loading-bar"></div>
            <div className="loading-bar"></div>
            <div className="loading-bar"></div>
        </div>
    )
}